import React from 'react';

import Pending from './PendingSuppliers';
import ActiveSuppliers from './ActiveSuppliers';

const Suppliers = () => (
  <div>
    <ActiveSuppliers />
    <Pending />
  </div>
);

export default Suppliers;
